import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { GetSelectList, GetSelectPageList as _GetSelectPageList, LoadData } from '@/api/ListParam';
export default {
  name: 'fast-search',
  components: {},
  data: function data() {
    return {
      fastOptionData: [],
      columns: [],
      formData: {
        Page: 1,
        Limit: 15,
        ParamList: []
      },
      selectFormData: [],
      total: 0,
      searchList: []
    };
  },
  created: function created() {
    this.handleSearchTableLoad();
  },
  props: {
    columnsWhere: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mainKeys: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    searchBtn: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  watch: {
    columnsWhere: {
      handler: function handler(val) {
        var _this = this;

        if (val) {
          this.handleSearchTableLoad().then(function () {
            _this.columns = _this.searchList;

            for (var index in _this.columns) {
              _this.selectFormData.push({
                Page: 1,
                Limit: 15,
                PARAM_NAME: _this.columns[index].PARAM_NAME,
                Key: ''
              });

              _this.fastOptionData.push({
                CODE: '',
                NAME: ''
              });
            }
          });
        }
      },
      immediate: true
    }
  },
  methods: {
    i18nOption: function i18nOption(CODE) {
      return this.$t('orderStatus.' + CODE);
    },
    handleSearchTableLoad: function handleSearchTableLoad() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return LoadData({
                  Page: 1,
                  Limit: 999
                });

              case 2:
                res = _context.sent;
                console.log('快速查询res', res);
                _this2.searchList = [];

                if (res.code === 0) {
                  res.data.forEach(function (item, index) {
                    if (item.IS_FAST_SEARCH === 'Y') {
                      _this2.searchList.push(item);
                    }
                  });
                }

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    width: function width(w, right) {
      if (!w) {
        w = 160;
      }

      if (right) {
        return "width: ".concat(w, "px;margin-right:").concat(right, "px");
      }

      return "width: ".concat(w, "px");
    },
    // 下拉数据
    getSelectData: function getSelectData(index) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, tempData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return GetSelectList(_this3.selectFormData[index]);

              case 2:
                res = _context2.sent;

                if (res.code === 0) {
                  tempData = [];

                  _this3.fastOptionData.forEach(function (u) {
                    return tempData.push(u);
                  });

                  tempData[index] = res.data;
                  _this3.fastOptionData = tempData;
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    GetSelectPageList: function GetSelectPageList() {
      var _arguments = arguments,
          _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var index, cindex, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                index = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 0;
                // let cindex = Object.keys(this.$refs)[0]
                cindex = index; // console.log(cindex, index)

                _context3.next = 4;
                return _GetSelectPageList(_this4.selectFormData[cindex]);

              case 4:
                res = _context3.sent;

                if (res.code === 0 && res.data.length > 0) {
                  _this4.fastOptionData[cindex] = res.Result; // console.log('GetSelectPageList', res.Result, this.fastOptionData[cindex])

                  _this4.total = res.TotalCount;
                } else {
                  _this4.fastOptionData[cindex] = [{
                    CODE: '',
                    NAME: ''
                  }];
                  _this4.total = 0;
                }

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    pageSelect: function pageSelect(index) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.selectFormData[index].Page = 1;

                _this5.GetSelectPageList(index);

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    sizeChange: function sizeChange(val, index) {
      console.log('sizeChange', val, index);
      this.selectFormData[index].Limit = val;
      this.GetSelectPageList(index);
    },
    currentChange: function currentChange(val, index) {
      // let index = Object.keys(this.$refs)[0]
      // console.log('currentChange', val, index, this.selectFormData[index])
      this.selectFormData[index].Page = val;
      this.GetSelectPageList(index);
    },
    noPageSelect: function noPageSelect(index) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.getSelectData(index);

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    fastSearch: function fastSearch() {
      this.formData.Page = 1;
      this.formData.ParamList = this.getParamList();
      this.$emit('enter', this.formData);
    },
    getParamList: function getParamList() {
      var ParamList = [];
      this.columns.forEach(function (item) {
        if (item.PARAM_VALUE) {
          ParamList.push({
            PARAM_NAME: item.PARAM_NAME,
            ACTION_TYPE: item.ACTION_TYPE,
            FIELD_NAME: item.FIELD_NAME,
            PARAM_VALUE: item.PARAM_VALUE.toString(),
            DATA_TYPE: item.DATA_TYPE
          });
        }
      });
      return ParamList;
    }
  }
};